<template>
  <div class="container">
    <van-list
      v-model="loading"
      :finished="finished"
      :error.sync="error"
      error-text="请求失败，点击重新加载"
      @load="getArticleList"
    >
      <div v-for="(item, index) in list" :key="index">
        <!-- 样式一 -->
        <div
          class="classOne classThree"
          v-if="item.CoverNum == 1"
          @click="toArticleDetail(item.ContentID)"
        >
          <van-image fit="cover" class="imgItemThree" :src="item.Thumbnail" />
          <div class="classTitle">
            <div>{{ item.Title }}</div>
            <div class="personBox">
              <div>{{ item.ReadNum }}阅读</div>
              <div>{{ item.CreateDateDesc }}</div>
            </div>
          </div>
        </div>
        <!-- 样式二 -->
        <div
          class="classOne"
          v-if="item.CoverNum == 3"
          @click="toArticleDetail(item.ContentID)"
        >
          <div class="classTitle title">{{ item.Title }}</div>
          <div class="imgBox">
            <van-image
              fit="cover"
              v-for="(inner, innerIndex) in item.ThumbnailList"
              :key="innerIndex"
              :src="inner"
            />
          </div>
          <div class="personBox">
            <div>{{ item.ReadNum }}阅读</div>
            <div>{{ item.CreateDateDesc }}</div>
          </div>
        </div>
        <!-- 样式三 -->
        <div
          class="classOne"
          v-if="item.CoverNum == 0"
          @click="toArticleDetail(item.ContentID)"
        >
          <div class="classTitle title">{{ item.Title }}</div>
          <div class="personBox">
            <div>{{ item.ReadNum }}阅读</div>
            <div>{{ item.CreateDateDesc }}</div>
          </div>
        </div>
      </div>
    </van-list>

    <div class="noDataBox" v-if="list.length == 0">
      <span class="iconfont icon-kong"></span>
      <div>什么也没有！</div>
    </div>
  </div>
</template>
<script>
import { List, Image } from "vant";
import { articleList } from "@/api/article";
export default {
  name: "articleList",
  components: {
    "van-list": List,
    "van-image": Image,
  },
  data() {
    return {
      error: false,
      loading: false,
      finished: false,
      total: 0,
      pageIndex: 1,
      list: [],
    };
  },
  methods: {
    //跳转文章详情
    toArticleDetail(id) {
      this.$router.push({
        path: "/articleDetail",
        query: { id: id },
      });
    },

    //获取文章列表
    getArticleList() {
      var that = this;
      var data = {
        Keyword: "",
        Page: {
          PageSize: 10,
          PageIndex: that.pageIndex,
        },
        MemberId: that.$route.query.mid,
      };
      articleList(data)
        .then((res) => {
          if (that.pageIndex == 1) {
            that.list = [...res.Data.List];
          } else {
            that.list = [...that.list, ...res.Data.List];
          }
          that.total = res.Data.Total;
          that.pageIndex += 1;
          that.loading = false;
          if (that.list.length >= that.total) {
            that.finished = true;
          }
        })
        .catch((err) => {
          that.loading = false;
          that.error = true;
          that.Common.showMsg(err);
        });
    },
  },
};
</script>
<style lang="less" scoped>
.container {
  min-height: 100vh;
  padding: 0px 0px 20px 0px;
  box-sizing: border-box;
  .classOne {
    background-color: #fff;
    margin: 10px 18px 0px 11px;
    padding-bottom: 10px;
    box-sizing: border-box;
    border-bottom: 1px solid #eee;
    .classTitle {
      font-size: 14px;
      color: #6f6f6f;
      width: 215px;
      margin-left: 14px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
    .title {
      width: 100%;
      margin-left: 0px;
    }
    .van-image {
      display: block;
      width: 110px;
      height: 75px;
      /deep/ .van-image__img {
        border-radius: 5px;
      }
    }
    .imgBox {
      display: flex;
      flex-direction: row;
      margin-block-end: 13px;
      margin-top: 12px;
      .van-image {
        display: block;
        width: 100px;
        height: 75px;
        margin-right: 16px;
        /deep/ .van-image__img {
          border-radius: 5px;
        }
        &:nth-of-type(3n + 0) {
          margin-right: 0;
        }
      }
    }

    .personBox {
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: #949494;
      font-size: 12px;
      margin-top: 15px;
    }
  }
  .classThree {
    display: flex;
    flex-direction: row;
    background-color: #fff;
  }
}
</style>

